import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../Auth/Login.vue'
import Home from '../views/Home.vue'
import Register from '../Auth/Register.vue'
import VerifyEmail from '../Auth/VerifyEmail.vue'
import Approve from '../views/approve.vue'
import approveEmail from '../Auth/approveEmail.vue'
import Profile from '../views/Profile.vue'

// import store from '@/store'
Vue.use(VueRouter)

const routes = [
  {
    name: 'home',
    path: '/',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { guestOnly: true }
  },
  {
    name: 'register',
    path: '/register',
    component: Register,
    meta: { guestOnly: true }
  },
  {
    name: 'verify',
    path: '/verify',
    component: VerifyEmail,
    meta: { guestOnly: true }
  },
  {
    name: 'confirm',
    path: '/confirm',
    component: approveEmail
  },
  {
    name: 'approve',
    path: '/approve',
    component: Approve
  },
  {
    name: 'profile',
    path: '/profile',
    component: Profile,
    meta: { guestOnly: false }
  }

]

const router = new VueRouter({
  mode: 'history',
  // base: '/flights/',
  routes
})

router.beforeEach((to, from, next) => {
  // const isLoggedIn = !!store.state.user
  const isLoggedIn = localStorage.getItem('BVtoken')
  console.log('bsmallah', isLoggedIn)
  if (to.meta.requiresAuth && !isLoggedIn) {
    console.log('login')
    next({ name: 'login' })
  } else if (to.meta.guestOnly && isLoggedIn) {
    next({ name: 'home' })
    console.log('home')
  } else {
    next()
  }
})
export default router
